const getFormatDate = (currentDate) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const months = ['Jan', 'Feb', "Mar", 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Nov', 'Dec']
    const now = new Date(currentDate);
    const day = now.getDay();
    const date = now.getDate();
    const month = now.getMonth();
    // return {day: days[day], date, month: months[month]};
    return `${days[day]}, ${date} ${months[month]}`;
}

export {
    getFormatDate
};